import type { TUserDatabase } from "@/apis/odin/apiODIN";

export const getSelectedDatabasesFromLoadedDatabases = ({
    userSelectedDatabases,
    availableDatabases,
}: {
    userSelectedDatabases: number[];
    availableDatabases: TUserDatabase[];
}) => {
    return availableDatabases.filter(database =>
        userSelectedDatabases?.includes(database.databaseId),
    );
};
